import { Notify } from 'quasar';

import { SUCCESS_NOTIF_MSGS } from '@/helpers/consts.ts';
import { FileActions } from './types.ts';

export default function notificationHandler(action: FileActions) {
  let msg: string;

  switch (action) {
    case FileActions.HardDelete:
      msg = SUCCESS_NOTIF_MSGS.DELETED;
      break;
    case FileActions.Move:
      msg = SUCCESS_NOTIF_MSGS.MOVED;
      break;
    case FileActions.Rename:
      msg = SUCCESS_NOTIF_MSGS.RENAMED;
      break;
    case FileActions.Upload:
      msg = SUCCESS_NOTIF_MSGS.UPLOADED;
      break;
    default:
      msg = 'Success';
  }

  Notify.create({
    type: 'positive',
    position: 'top-right',
    message: msg,
  });
}
